import React from "react";
import { Gift, Percent, Plus, Ticket } from "lucide-react";
import { AdminPageHeader, Badge, Button, ListRow, Page, Panel, StatCard, StatGrid } from "../AdminKit";

const coupons = [
  { name: "신규 가입 10% 할인", code: "WELCOME10", used: "342회", status: "진행중" },
  { name: "VIP 무료배송", code: "VIPSHIP", used: "89회", status: "진행중" },
  { name: "여름 시즌 30,000원 할인", code: "SUMMER30", used: "127회", status: "예약" },
  { name: "블랙 프라이데이 15%", code: "BLACK15", used: "1,284회", status: "종료" },
];

export default function AdminCoupons() {
  return (
    <Page>
      <AdminPageHeader title="쿠폰 관리" description="발급, 사용률, 예약 쿠폰을 관리하고 캠페인별 효과를 확인합니다." />
      <StatGrid>
        <StatCard><Ticket size={24} /><span>활성 쿠폰</span><strong>12개</strong></StatCard>
        <StatCard><Gift size={24} /><span>이번 달 사용</span><strong>1,842회</strong></StatCard>
        <StatCard><Percent size={24} /><span>평균 전환율</span><strong>18.6%</strong></StatCard>
      </StatGrid>
      <Panel>
        <header><h2>쿠폰 목록</h2><Button $primary><Plus size={16} /> 쿠폰 생성</Button></header>
        {coupons.map((coupon) => (
          <ListRow key={coupon.code} $columns="1fr 130px 120px 100px">
            <div><strong>{coupon.name}</strong><span>{coupon.code}</span></div>
            <span>{coupon.used}</span>
            <Badge $bg={coupon.status === "종료" ? "#f3f4f6" : "#eaf3ff"} $fg={coupon.status === "종료" ? "#66758f" : "#2f70cf"}>{coupon.status}</Badge>
            <Button>수정</Button>
          </ListRow>
        ))}
      </Panel>
    </Page>
  );
}
